export const formatDate = (date: Date | null) => {
	if (date) return new Date(date).toLocaleDateString('ro-RO');
	else return '-';
};

export const formatDateTime = (date: Date | null) => {
	if (date) return new Date(date).toLocaleString('ro-RO');
	else return '-';
};
